import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import styled, {css} from 'styled-components'

export const StyledAdministrativeActivitiesView = styled.div(
    ({theme: {palette, spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 200px)) auto;
        gap: ${spacing * 3}px;
        & > div:not(:last-child) {
            border-right: 1px solid ${palette.neutral[200]};
            padding: 0 ${spacing}px;
        }
    `
)

export const StyledAttachmentButton = styled(ButtonLink)(
    () => css`
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        align-self: flex-start;
        white-space: nowrap;
        display: inline-block;
    `
)
